import * as React from 'react';
import cx from 'classnames';
import { getYearAndMonth, getNowMonth } from '../utils';
import { CalendarBox, Week, cyRcnnProps } from '../common';
import 'dayjs/locale/zh-tw';
let dayjs = require('dayjs');
const calendarData = require('../calendarData.json');

function diffDate(date1: string, date2: string) {
    if (!date1.length || !date2.length) return '?';
    const d1 = new Date(date1).getTime();
    const d2 = new Date(date2).getTime();
    const timeDiff = d2 - d1;
    const dayDiff = timeDiff / (1000 * 3600 * 24);
    return dayDiff;
}

function getToday() {
    return new Date().toISOString().slice(0, 10);
}

// 拿到今天月份後第六個月的月份
function todayAfterSixMonth() {
    const CurrentDate = new Date();
    CurrentDate.setMonth(CurrentDate.getMonth() + 6);
    return CurrentDate.toISOString().slice(0, 7);
}

export interface DateLabelProps {
    isStart?: boolean;
    isActive: boolean;
    title: string;
    date: string;
    language: any;
    onClick: () => void;
    panelProps?: string;
    showWeek?: boolean;
}
const DateLabel = ({
    isStart = false,
    isActive = false,
    title,
    date,
    language,
    onClick = () => {},
    panelProps,
    showWeek,
}: DateLabelProps) => {
    const d = date.split('-');
    const MM = d.length > 1 && d[1];
    const DD = d.length > 1 && d[2];
    const dd =
        d.length > 1 &&
        dayjs(date)
            .locale('zh-tw')
            .format('dd');
    const format = language.format;
    const weekday = showWeek ? ` 週${dd}` : '';

    return (
        <div
            className={cx({
                start_section: isStart,
                end_section: !isStart,
                active: isActive,
            })}
            onClick={onClick}
        >
            <h5 className="title">{title}</h5>
            <div className="date">
                {!date.length
                    ? null
                    : format && Object.keys(format).length > 0
                    ? `${MM}${format.month}${DD}${format.date}${weekday}`
                    : `${MM}/${DD}`}
            </div>
        </div>
    );
};
interface ThisProps extends cyRcnnProps {
    activeInput: number;
    startLabelTitle: string;
    endLabelTitle: string;
    onDateClickCallBack: (order: any, date: string) => void;
    onClickConfirm: () => void;
    customDiffTxt: (diff: any) => void;
    startMonth: string;
    endMonth: string;
    panelName: string;
    totalDateClass: any;
    switchLabelCallBack: (target: any, selectedStartDate: string) => void;
    panelProps?: string;
    showWeek?: boolean;
}
export interface ThisStates {
    selectedStartDate: string;
    selectedEndDate: string;
    activeInput: number;
    startDate: string;
    monthRange: any[];
    scrollIndex: number;
    lastScrollPos: number;
}

const calendarRef = React.createRef<HTMLDivElement>();

class CyRcmm extends React.PureComponent<ThisProps, ThisStates> {
    static defaultProps = {
        doubleChoose: false, // 選一天或選兩天
        activeInput: 0,
        startLabelTitle: '去程',
        endLabelTitle: '回程',
        onDateClickCallBack: () => {}, // 選完日期的 call back. return: activeInput, date
        onClickConfirm: () => {},
        customDiffTxt: (txt: string) => txt,
        startDate: getToday(), // 最小可選日
        endDate: '', // 最大可選日
        startMonth: getNowMonth(), // 月曆從幾月份開始畫
        endMonth: todayAfterSixMonth(),
        panelName: '', // 傳入面板名稱
        language: calendarData.data,
        startTxt: '去程',
        endTxt: '回程',
        showWeek: false,
    };

    constructor(props: ThisProps) {
        super(props);
        this.state = {
            selectedStartDate: this.props.selectedStartDate || '',
            selectedEndDate: this.props.selectedEndDate || '',
            activeInput: this.props.activeInput,
            startDate: this.calcStartDate(),
            monthRange: this.calcMonthArray(),
            // scroll
            scrollIndex: 0,
            lastScrollPos: 0,
        };
    }
    componentDidUpdate(prevProps: any, prevState: any) {
        if (prevProps.endMonth !== this.props.endMonth) {
            this.updateMonthRange();
        }
    }

    // 卷軸計算
    handleScroll = (e: any) => {
        let scrollIndex = this.state.scrollIndex;
        const { lastScrollPos } = this.state;
        const calenderAll: any = calendarRef.current!.childNodes;
        let now =
            Math.ceil(e.currentTarget.scrollTop) <= 0 ? 0 : Math.ceil(e.currentTarget.scrollTop);
        const objoffsetTop = calenderAll[scrollIndex].offsetTop - 120 - 50;

        if (lastScrollPos > now) {
            // 向上滑
            if (now < objoffsetTop) {
                scrollIndex--;
            }
            this.setState({ lastScrollPos: now, scrollIndex });
        } else if (lastScrollPos < now) {
            // 向下滑
            if (now > objoffsetTop + (calenderAll[1].offsetTop - 120)) {
                scrollIndex++;
            }
            this.setState({ lastScrollPos: now, scrollIndex });
        }
    };

    updateMonthRange = () => {
        this.setState({
            monthRange: this.calcMonthArray(),
        });
    };

    calcStartDate() {
        const { startDate, activeInput, selectedStartDate } = this.props;

        const isStart = activeInput === 0;
        if (isStart) {
            return startDate;
        } else {
            return selectedStartDate ? selectedStartDate : startDate;
        }
    }

    calcMonthArray() {
        const { startMonth, endMonth } = this.props;

        const [year, month] = getYearAndMonth(startMonth);
        const [y2, m2] = getYearAndMonth(endMonth);

        // 計算startMonth 跟 endMonth差幾個月
        let diffmonth = (y2 - year) * 12;
        diffmonth -= month - 1;
        diffmonth += m2;
        let arr: any = [];
        for (let i = 0; i < diffmonth; i++) {
            arr.push(new Date(year, month - 1 + i, 1, 8));
        }
        return arr;
    }

    startDateValueRule = (date: string) => {
        const { activeInput, selectedStartDate } = this.state;
        const { panelName } = this.props;
        const isStart = activeInput === 0;

        switch (panelName) {
            case '':
            default:
                return isStart ? date : selectedStartDate;
        }
    };
    onDateClick = (date: string) => {
        const { activeInput, selectedStartDate } = this.state;

        const { doubleChoose, startDate } = this.props;

        const isStart = activeInput === 0;
        const startDateValue = this.startDateValueRule(date);
        const endDateValue = isStart ? '' : date;
        const start = doubleChoose ? (isStart ? startDateValue : startDate) : startDate;
        this.setState(prevState => ({
            ...prevState,
            startDate: start,
            selectedStartDate: startDateValue,
            selectedEndDate: endDateValue,
            activeInput: doubleChoose ? (isStart ? 1 : 0) : 0,
        }));
        this.props.onDateClickCallBack && this.props.onDateClickCallBack(activeInput, date);
        this.props.switchLabelCallBack &&
            this.props.switchLabelCallBack(
                doubleChoose ? (isStart ? 1 : 0) : 0,
                date || selectedStartDate
            );
    };

    setStartDay = (start: string, activeInput: number) => {
        const { selectedStartDate } = this.state;
        const { panelName } = this.props;
        switch (panelName) {
            case 'hotel':
                if (activeInput === 1 && selectedStartDate !== '') {
                    return dayjs(selectedStartDate).format('YYYY-MM-DD');
                }
                return new Date().getHours() > 11
                    ? dayjs()
                          .add(1, 'day')
                          .format('YYYY-MM-DD')
                    : dayjs().format('YYYY-MM-DD');
            case '':
            default:
                if (activeInput === 1 && selectedStartDate !== '') {
                    return dayjs(selectedStartDate).format('YYYY-MM-DD');
                }
                return dayjs().format('YYYY-MM-DD');
        }
    };

    // setEndDay = () => {
    //     const { panelName, endDate } = this.props;

    //     const { activeInput, selectedStartDate } = this.state;

    //     switch (panelName) {
    //         case 'hotel':
    //             if (activeInput === 1 && selectedStartDate !== '') {
    //                 console.log('唷唷唷', activeInput, selectedStartDate);
    //                 return dayjs(selectedStartDate)
    //                     .add(30, 'days')
    //                     .format('YYYY-MM-DD');
    //             }
    //             return endDate;
    //         // case 'vacationPersonal':
    //         //     return dayjs(selectedStartDate).add(30, 'days').format('YYYY-MM-DD');
    //         case '':
    //         default:
    //             return endDate;
    //     }
    // };

    switchLabel = (target: number) => {
        const { selectedStartDate } = this.state;
        const { startDate } = this.props;

        // const isStart = (target === 0);
        const start = selectedStartDate || startDate;

        this.setState(prevState => ({
            ...prevState,
            startDate: this.setStartDay(start, target),
            activeInput: target,
        }));

        this.props.switchLabelCallBack && this.props.switchLabelCallBack(target, selectedStartDate);
    };

    mChangeYearMonth = (e: any) => {
        const selectDate = e.target.value;
        const { monthRange } = this.state;
        const minDate = monthRange[0];
        const maxDate = monthRange[monthRange.length - 1];
        let matchIndex;

        monthRange.forEach((v, i) => {
            if (selectDate === dayjs(v).format('YYYY-MM')) {
                matchIndex = i;
            }
        });

        if (new Date(selectDate).getTime() >= new Date(maxDate).getTime()) {
            matchIndex = monthRange.length - 1;
        }

        if (new Date(selectDate).getTime() <= new Date(minDate).getTime()) {
            matchIndex = 0;
        }
        let childNode: any = calendarRef.current!.childNodes;
        calendarRef.current!.scrollTo(
            this.state.lastScrollPos,
            childNode[matchIndex].offsetTop - 120
        );
        this.setState({ scrollIndex: matchIndex });
    };

    render() {
        const {
            startTxt,
            endTxt,
            doubleChoose,
            startLabelTitle,
            endLabelTitle,
            onClickConfirm,
            customDiffTxt,
            totalDateClass,
            language,
            customInvalidDaysArr,
            highLightDaysArr,
            panelProps,
            endDate,
            showWeek,
        } = this.props;

        const {
            activeInput,
            selectedStartDate,
            selectedEndDate,
            startDate,
            monthRange,
        } = this.state;

        const props = {
            startDate,
            endDate,
            selectedStartDate,
            selectedEndDate,
            startTxt,
            endTxt,
            doubleChoose,
            isMobile: true,
            onDateClick: this.onDateClick,
        };

        const dayDiff = diffDate(selectedStartDate, selectedEndDate);
        const showTxt = customDiffTxt(dayDiff);

        const selectMinDate = dayjs(monthRange[0]).format('YYYY-MM');
        const selectMaxDate = dayjs(monthRange[monthRange.length - 1]).format('YYYY-MM');

        return (
            <div className="cy_rcln">
                <div className="label_box">
                    <div className="selected_info">
                        <DateLabel
                            isStart
                            isActive={activeInput === 0}
                            title={startLabelTitle}
                            date={selectedStartDate}
                            onClick={() => {
                                this.switchLabel(0);
                            }}
                            language={language}
                            panelProps={panelProps}
                            showWeek={showWeek}
                        />
                        {doubleChoose ? (
                            <DateLabel
                                isActive={activeInput !== 0}
                                title={endLabelTitle}
                                date={selectedEndDate}
                                onClick={() => {
                                    this.switchLabel(1);
                                }}
                                language={language}
                                panelProps={panelProps}
                                showWeek={showWeek}
                            />
                        ) : null}
                    </div>
                    <Week language={language.date} />
                </div>
                <div
                    className="calendar_content"
                    ref={calendarRef}
                    onTouchStart={this.handleScroll}
                    onTouchMove={this.handleScroll}
                    onScroll={this.handleScroll}
                >
                    {monthRange.map((v, idx) => (
                        <CalendarBox
                            key={v}
                            startMonth={v}
                            mChangeYearMonth={this.mChangeYearMonth}
                            scrollIndex={this.state.scrollIndex}
                            itemIndex={idx}
                            selectMinDate={selectMinDate}
                            selectMaxDate={selectMaxDate}
                            {...props}
                            language={language}
                            startTxt={this.props.startTxt}
                            endTxt={this.props.endTxt}
                            customInvalidDaysArr={customInvalidDaysArr}
                            highLightDaysArr={highLightDaysArr}
                        />
                    ))}
                </div>
                <button className="confirm_btn" onClick={onClickConfirm}>
                    {language.mButton}
                    {dayDiff === '?' ? null : (
                        <span
                            className={totalDateClass ? totalDateClass : ''}
                        >{`(${showTxt})`}</span>
                    )}
                </button>
            </div>
        );
    }
}

export default CyRcmm;
